import { render, staticRenderFns } from "./BrandPlatform.vue?vue&type=template&id=4d8ad9f0&lang=pug"
import script from "./BrandPlatform.vue?vue&type=script&lang=js"
export * from "./BrandPlatform.vue?vue&type=script&lang=js"
import style0 from "./BrandPlatform.vue?vue&type=style&index=0&id=4d8ad9f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports